import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { SkipLink } from './components/layout/SkipLink';
import { Hero } from './components/sections/Hero';
import { Services } from './components/sections/Services';
import { About } from './components/sections/About';
import { Portal } from './components/sections/Portal';
import { Contact } from './components/sections/Contact';
import { useReveal } from './hooks/useReveal';

export function App() {
  useReveal();

  return (
    <>
      <SkipLink />
      <Header />
      <main id="main">
        <Hero />
        <Services />
        <About />
        <Portal />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
